import React from "react";
import "../../styles/Aplic2027.scss";

const Aplic2027: React.FC = () => {
  return (
    <section id="what-is-aplic" className="aplic2027-section">
      <div className="aplic2027-container">

        <div className="top-row">
          <div className="title-container">
            <p className="aplic-title">
              <span className="what">What is</span>
              <br />
              <span className="aplic">APLIC 2027?</span>
            </p>
          </div>

          <div className="description-container">
            <p className="aplic-description">
              The APLIC congress is aimed at promoting professionalism of financial
              services advisory in the region. Through various joint educational and
              professional training courses, seminars, and conventions, the APLIC
              congress aims to raise the standard of professionalism and business
              practices of financial advisors and managers in the region.
            </p>
          </div>
        </div>

        <div className="aplic-buttons">
          <a href="/our-team" className="aplic-btn btn-1">Our Team</a>
          <a href="/success-in-motion" className="aplic-btn btn-2">Success in Motion</a>
          <a href="#past-event" className="aplic-btn btn-3">Past Event</a>
          <a href="https://aplic2027.gottit.io/" target="_blank"  rel="noopener noreferrer"  className="aplic-btn btn-4">Register Now</a>
        </div>

      </div>
    </section>
  );
};

export default Aplic2027;
